import api from '@/api';

import { API_BASE_URL } from '..';
import {
  CustomerCategory,
  CustomerCategoryCreateRequest,
  CustomerCategoryEditRequest,
  ListCustomersCategoryQuery,
} from './CustomerCategory.types';
import { PageResult } from '@/core/request/PageResult';

const CONTROLLER_URL = `${API_BASE_URL}/categories`;

export async function getListCustomerCategory(
  params?: ListCustomersCategoryQuery,
) {
  const result = (await api.get(CONTROLLER_URL, {
    ...params,
  })) as unknown;

  return result as PageResult<CustomerCategory>;
}

export async function getCustomerCategory(id?: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, {})) as unknown;

  return result as CustomerCategory;
}

export async function createCustomerCategory(
  obj: CustomerCategoryCreateRequest,
) {
  const result = (await api.post(CONTROLLER_URL, obj, null)) as unknown;

  return result;
}

export async function updateCustomerCategory(obj: CustomerCategoryEditRequest) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function removeCustomerCategory(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}
